export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/GT-35ee046448ba6df423bc93c154ebdbf2.png";